export enum MarginType {
    Travel = 1,
    WorkforceDisruptionSample = 2
}
